import { Button } from '@wundo/ui';

export function TryAgain({ onClick }: { onClick: () => void }) {
  return (
    <Button variant='quiet' size='sm' data-ui='retry' onClick={onClick}>
      Try again
    </Button>
  );
}
